import React from 'react';
import './CEOMessagePage.css';

const HeroBlock = ({ label, title, text, image }) => (
  <section className="enhanced-hero" style={{ backgroundImage: `url(${image})` }}>
    <div className="container enhanced-hero-grid">
      <div className="enhanced-copy reveal-left">
        <span className="section-label eyebrow-dark">{label}</span>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{text}</p>
        <div className="hero-actions">
          <a href="/contact-us" className="btn btn-primary">Get Free Consultation</a>
          <a href="/packages" className="btn btn-outline">View Packages</a>
        </div>
        <div className="hero-metrics">
          <span><strong>6,500+</strong>Vehicles Served</span>
          <span><strong>24/7</strong>Monitoring</span>
          <span><strong>2019</strong>Since</span>
        </div>
      </div>
    </div>
  </section>
);

const CEOMessagePage = () => (
  <main className="enhanced-page ceo-enhanced">
    <HeroBlock
      label="CEO Message"
      title="A Message of Trust, <em>Security</em> & Innovation"
      text="At DTS, we believe every vehicle deserves protection and every business fleet deserves intelligent operational control. Our mission is to provide dependable tracking solutions with responsive human support behind every journey."
      image="/dts-assets/ai/ceo-hero.png"
    />

    <section className="enhanced-section ceo-spotlight-section">
      <div className="container">
        <div className="ceo-spotlight reveal">
          <div className="ceo-portrait-shell">
            <img src="/dts-assets/team/shahid-nawaz.jpg" alt="Shahid Nawaz" className="ceo-portrait" />
          </div>
          <div className="ceo-spotlight-copy">
            <span className="section-label">Leadership</span>
            <h2>Shahid Nawaz</h2>
            <p className="ceo-role">Chief Executive Officer — Dynamic Tracking Solutions Pvt. Ltd.</p>
            <p>With a strong focus on security, customer trust, and long-term service quality, our leadership continues to drive DTS forward as a modern GPS tracking and fleet management company built for Pakistan’s real-world needs.</p>
            <div className="ceo-tags">
              <span>Visionary Leadership</span>
              <span>Customer-Centered Service</span>
              <span>Smart Tracking Innovation</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="enhanced-section alt">
      <div className="container split-grid ceo-content-grid">
        <div className="feature-panel ceo-letter reveal-left">
          <span className="section-label">From The CEO</span>
          <h2>We Build More Than Trackers — We Build Confidence</h2>
          <p>When we founded DTS in 2019, we saw a clear gap in the Pakistani market. Businesses needed more than a GPS device; they needed a complete, reliable, and intelligent tracking partner.</p>
          <p>Our team has built a platform customized to Pakistani roads, customer expectations, and real operational challenges. From corporate fleets in Karachi to individual car owners across Pakistan, our goal is to provide peace of mind and complete control.</p>
          <p>We are proud to serve thousands of customers and remain committed to growing with the same personal attention and service quality that defined DTS from day one.</p>
          <h3>— Shahid Nawaz, CEO</h3>
        </div>

        <div className="media-card reveal ceo-vision-card">
          <img src="/dts-assets/ai/team-hero.png" alt="DTS leadership and platform vision" />
        </div>
      </div>
    </section>

    <section className="enhanced-section dark-band">
      <div className="container card-grid">
        {[
          ['Trust', 'Long-term customer relationships built on transparency, consistency, and dependable support.'],
          ['Innovation', 'In-house technology customized for real business requirements and local operating realities.'],
          ['Growth', 'Expanding solutions while staying focused on Pakistani customers and lasting service quality.'],
        ].map((item, index) => (
          <div className="info-card reveal" key={item[0]}>
            <div className="info-icon">{['TR', 'IN', 'GR'][index]}</div>
            <h3>{item[0]}</h3>
            <p>{item[1]}</p>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default CEOMessagePage;
